import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import FieldError from 'ui-library/FieldError';
import {LABEL_STYLES} from 'ui-library/inputs/InputConstants';
import TextField from 'ui-library/inputs/TextField';

export interface DataFrameNameFieldProps {
  hasUserEdits: boolean;
  name: string;
  onNameChange: (newName: string) => void;
  disabled?: boolean;
}

export default function DataFrameNameField(props: DataFrameNameFieldProps): JSX.Element {
  return (
    <>
      <TextField
        className={css(styles.textField)}
        hasError={props.hasUserEdits && props.name === ''}
        label="Table name" // Hidden labels aid screen reader usability
        labelStyle={LABEL_STYLES.HIDDEN}
        onChange={(e) => {
          props.onNameChange(e.target.value);
        }}
        placeholder="Table name"
        value={props.name}
        disabled={props.disabled}
      />
      {props.hasUserEdits && props.name === '' && <FieldError message="Please enter a name" compact={true} />}
    </>
  );
}

const styles = StyleSheet.create({
  textField: {
    position: 'relative',
  },
});
